import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useYoutubeVideoID } from '~/composables/useYoutubeVideoID';
export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubePlayer',
  props: {
    videoUrl: {
      type: String,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var YoutubeThumbnail = function YoutubeThumbnail() {
      return import('~/components/Atoms/YoutubeThumbnail.vue');
    };
    var displayVideo = ref(false);
    var videoId = useYoutubeVideoID(props.videoUrl);

    /**
     * Toggles the video iframe display
     */
    function toggleVideo() {
      displayVideo.value = true;
    }
    return {
      __sfc: true,
      YoutubeThumbnail: YoutubeThumbnail,
      props: props,
      displayVideo: displayVideo,
      videoId: videoId,
      toggleVideo: toggleVideo
    };
  }
});